import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

    /**
   * Description: Método que llama el servicio web que elimina o destruye la sesión
   * Autor: Diego Diaz
   * @param documentId documento del usuario
   * @param token token de seguridad del usuario
   * @return Listado de beneficios 
   */
  logOut(documentId, token) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_LOGOUT, {"documentId":documentId, "token":token});
  }

}
